/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from 'react'
import NavigationBar from '../components/NavBar'
import { message} from '../components/SocketIO'
import { useSelector} from 'react-redux';
import { 
    selectDrivers
} from '../features/drivers/driversSlice'
import GetInvoice from '../backendHandler/invoicesRoute'

const Forms = (props) => {
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }
    // select the drivers from state
    const drivers = useSelector(selectDrivers)

    const [ timeStamp, setTimeStamp ] = useState('')
    const [ latestMessage, setLatestMessage ] = useState(null)
    const [ chatBoxState, setChatBoxState ] = useState(null)
    const [ chatBoxGate, setChatBoxGate ] = useState(false)
    const [ chatContent, setChatContent ] = useState([])
    
    // backend routes
    const [ requestGate, setRequestGate ] = useState(false)
    const [ handleSchedule, setHandleSchedule ] = useState(null)

    var CryptoJS = require("crypto-js");
    // testing stuff
    useEffect( () => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function deleteData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'DELETE', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            console.log('deletion completed')
            // return response ? response.json() : console.log('no reponse')
        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                });

            return response ? response.json() : console.log('no reponse')
        };

        // error list
        // let errorList = [24, 61, 76, 87, 90, 119, 137]

        // // hashtable helper function
        // function hashGen(array) {
        //     // instantiate object
        //     let hash = {}

        //     // loop through array and map driver_id to driver
        //     array.forEach( driver => {

        //         hash[driver.driver_id] = driver
        //     })

        //     // return the hash
        //     return hash

        // }

        // // step one: grab the drivers
        // getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {

        //     // lets go 50 at a time
        //     let subArray = response.results
            
        //     // make a hashmap of the drivers
        //     let hash = hashGen(subArray)

        //     // loop through the hash and grab the documents for each driver
        //     // make an array of the drivers keys
        //     let driverKeys = Object.keys(hash)

        //     async function awaitDataFunction() {
        //         const result = Promise.all(driverKeys.map( ele => {
        //             return postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
        //                         "driver_id": ele
        //                     }).then( response => {

        //                         // we are only interested with the vat
        //                         let vatMap = []

        //                         // loop through and find the vat
        //                         response.data.forEach( ele =>{
        //                             if (ele.name === "VAT") {
        //                                 vatMap.push(ele)
        //                             }
        //                         })

        //                         // add the documents to the driver
        //                         hash[ele].driverImagesNew = vatMap

        //                         return (
        //                             hash[ele]
        //                         )
        //             })
        //         }))
        //         return result
        //     }

        //     // call the function
        //     awaitDataFunction().then( response => {
        //         // filter for vat
        //         let vatList = response.filter( ele => ele.driverImagesNew.length > 0)

        //         // drivers with vat list
        //         let driversWithVat = vatList.map( driver => {
        //             let storageCheck = false

        //             // make an array of yhe storage bools
        //             let storageBools = driver.driverImagesNew.map( ele => ele.storageBool)

        //             // check each document if it is stored or not
        //             if (!storageBools.includes(false)) {
        //                 storageCheck = true
        //             }



        //             return {id: driver.driver_id, name: driver.name}
        //         })

        //         // array of all drivers that have vat on payroll
        //         let arrayOfVat = []

        //         // create a hashmap
        //         const hashMapper = (array) => {
        //             let hash = {}

        //             array.forEach( ele => {
        //                 hash[ele.id] = ele.name
        //             })

        //             return hash
        //         }


        //         // step one: grab the drivers
        //         getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
        //             response.results.forEach( ele => {
        //                 if (ele.vat) {
        //                     arrayOfVat.push(ele)
        //                 }
        //             })

        //             // check if the list is correct
        //             let hash = hashMapper(driversWithVat)

        //             // array to return
        //             let finalCheck = []

        //             console.log(hash)

        //             // loop through and check
        //             arrayOfVat.forEach( driver => {
        //                 if (!hash.hasOwnProperty(driver.driver_id)) {
        //                     finalCheck.push(driver)
        //                 }
        //             })

        //             console.log("final check: ", finalCheck)
        //         })
        //     })
        // })

        // Write a function that when given a URL as a string, parses out just the domain name and returns it as a string. For example:

    }, [])

    useEffect( () => {
        // connec to the socket
        message((err, message) => {
            setLatestMessage(message)
        }, 'I have joined the chat', props.user_name)
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        message((err, message) => {
            setLatestMessage(message)
        }, e.target.message.value, props.user_name)
        if (chatContent) {
            let currentChat = [...chatContent]
            currentChat.push(
                <div className='userDivContainer'>
                    <div className='userSpeaking'>
                        <h3 className='textInside'>
                            {e.target.message.value}
                        </h3>
                    </div>
                </div>
            )
            setChatContent(currentChat)
        }
        e.target.message.value = ''
    }

    // make the box appear or not
    const handleChangeChatBox = () => {
        chatBoxGate ? setChatBoxGate(false) : setChatBoxGate(true)
    }

    // initialize the chat box
    useEffect( () => {
        setChatBoxState(
            <div className='chatBoxFolded' onClick={handleChangeChatBox}>
                <h3>Chat</h3>
            </div>
        )
    }, [])

    // make the messages appear 
    useEffect( () => {
        if (latestMessage) {
            let name = latestMessage.name
            let message = latestMessage.message
            if (chatContent) {
                let currentChat = [...chatContent]
                currentChat.push(
                    <div className='guestDiv'>
                        <h3 className='textInsideName'>
                            {name}
                        </h3>
                        <div className='guestSpeaking'>
                            <h3 className='textInside'>
                                {message}
                            </h3>
                        </div>
                    </div>
                )
                setChatContent(currentChat)
            } else {
                let localArray = []
                localArray.push(
                    <div className='guestDiv'>
                        <h3 className='textInsideName'>
                            {name}
                        </h3>
                        <div className='guestSpeaking'>
                            <h3 className='textInside'>
                                {message}
                            </h3>
                        </div>
                    </div>
                )
                setChatContent(localArray)
            }
        }
    }, [latestMessage])

    // render the box
    useEffect( () => {
        if (chatBoxGate) {
            setChatBoxState(
                <div className='chatBox'>
                    <div onClick={handleChangeChatBox} className='exitChatBox'>
                        x
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className='chatContentDiv'>
                            {chatContent}
                        </div>
                        <div className='inputSection'>
                            <input type="text" name="message" id='inputChat'/>
                            <input type="submit" value="Send" id='submitButtonChat'/>
                        </div>
                    </form>
                </div>
            )
        } else {
            setChatBoxState(
                <div className='chatBoxFolded' onClick={handleChangeChatBox}>
                    <h3>Chat</h3>
                </div>
            )
        }
    }, [chatBoxGate, chatContent])

    const returnDateFunction = (selectedDate) => {
        console.log(selectedDate)
    }

    const handleClick = () => {
        requestGate ? setRequestGate(false) : setRequestGate(true)
    }

    return (
        <div className='home_content'>
            {handleSchedule}
            <NavigationBar title='Forms' superUser={props.superUser ? true : false} email={props.user_email}/>
            <div className='main_content_driver_documents'>
                {chatBoxState}
            {/* <button
                onClick={handleClick}
            >
                click me
            </button> */}
            </div>
        </div>
    )
}

export default Forms